import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';


import { Loader } from '@app/components';
import { getInvoicesList, setUserInvoices } from '@app/actions/subscribeActions';
import colors from '@app/constants/colors';

class SubscriptionHistory extends React.Component {
  componentDidMount() {
    const { getInvoicesList } = this.props;
    getInvoicesList();
  }

  componentWillUnmount() {
    const { setUserInvoices } = this.props;
    setUserInvoices([]);
  }

  renderNoTableItem = () => {
    const { isLoadingInvoices } = this.props;
    if (isLoadingInvoices) {
      return <Loader dotsColor={colors.FLAMENKO} />;
    }
    return <h3><FormattedMessage id="subscription.history.noSubscriptionHistory" /></h3>;
  }

  renderInvoicesList = () => {
    const { invoices } = this.props;

    return invoices.map(({
      name, invoiceId, invoiceDate, startdate, enddate, amountWithVat, status, paid,
    }) => (
      <tr key={invoiceId}>
        <td>{name}</td>
        <td>
          <FormattedDate
            value={new Date(invoiceDate * 1000)}
            month="short"
            year="numeric"
            day="numeric"
          />
        </td>
        <td>
          <FormattedDate
            value={new Date(startdate * 1000)}
            month="short"
            year="numeric"
            day="numeric"
          />
        </td>
        <td>
          <FormattedDate
            value={new Date(enddate * 1000)}
            month="short"
            year="numeric"
            day="numeric"
          />
        </td>
        <td>
          {amountWithVat}
          $
        </td>
        <td>{status}</td>
        <td>
          {paid}
          $
        </td>
      </tr>
    ));
  };

  render() {
    const { isLoadingInvoices, invoices } = this.props;
    return (
      <TableContainer>
        {
          invoices && invoices.length && !isLoadingInvoices
            ? (
              <React.Fragment>
                <TableTitle>
                  <FormattedMessage id="subscription.history.title" />
                </TableTitle>
                <Table>
                  <thead>
                    <tr>
                      <th><FormattedMessage id="subscription.history.order" /></th>
                      <th><FormattedMessage id="subscription.history.orderOn" /></th>
                      <th><FormattedMessage id="subscription.history.startDate" /></th>
                      <th><FormattedMessage id="subscription.history.endDate" /></th>
                      <th><FormattedMessage id="subscription.history.amountTtc" /></th>
                      <th><FormattedMessage id="subscription.history.status" /></th>
                      <th><FormattedMessage id="subscription.history.bill" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    { this.renderInvoicesList() }
                  </tbody>
                </Table>
              </React.Fragment>
            )
            : this.renderNoTableItem()
        }
      </TableContainer>
    );
  }
}

SubscriptionHistory.propTypes = {
  getInvoicesList: PropTypes.func.isRequired,
  setUserInvoices: PropTypes.func.isRequired,
  isLoadingInvoices: PropTypes.bool.isRequired,
  invoices: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ subscribe: { isLoadingInvoices, invoices } }) => ({
  isLoadingInvoices,
  invoices,
});

const mapDispatchToProps = {
  getInvoicesList,
  setUserInvoices,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionHistory);

const TableContainer = styled.div`
  max-width: 750px;
  overflow-x: auto;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const TableTitle = styled.h4`
  text-align: left;
  text-transform: uppercase;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  & td, & th {
    border: 3px solid ${colors.FLAMENKO};
  }
  & th {
    font-size : 0.8em;
    padding: 15px;
    @media (max-width: 599px) {
      padding: 10px;
    }
  }
  & td {
    font-size : 0.5em;
    text-align: center;
    padding: 15px;
    color: ${colors.RUST};
    @media (max-width: 599px) {
      padding: 10px;
    }
  }
`;
